import { ID } from 'app/components/Table/core/types';

import { trimObject } from 'app/helpers';

import { STATUS_USER } from './constants';
import { User, UserRequest, UsersQueryResponse } from './type';
import axios from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const API_URL = process.env.REACT_APP_API_URL;
const USER_URL = `${API_URL}/api`;
const getUsers = async (query: string): Promise<UsersQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const d = await axios.get(`${USER_URL}/orgs/${organizationId}/users?${query}`);
  return {
    data: d.data.data,
  };
};

const getUserById = async (id: ID): Promise<User | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const response = await axios.get(`${USER_URL}/orgs/${organizationId}/users/${id}`);
  const response_1 = response.data;
  return response_1.data;
};

const createUser = async (userRequest: UserRequest): Promise<User | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const response = await axios.post(
    `${USER_URL}/orgs/${organizationId}/users`,
    trimObject(userRequest),
  );
  const response_1 = response.data;
  return response_1.data;
};

const updateUser = async (idUser: ID, userRequest: UserRequest): Promise<User | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const response = await axios.patch(
    `${USER_URL}/orgs/${organizationId}/users/${idUser}`,
    trimObject(userRequest),
  );
  const response_1 = response.data;
  return response_1.data;
};

const deleteUser = (userId: ID): Promise<void> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios.delete(`${USER_URL}/orgs/${organizationId}/users/${userId}`);
};

const changeStatusUser = async (
  idUser: ID,
  request: {
    activate: STATUS_USER;
  },
): Promise<User | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const response = await axios.patch(
    `${USER_URL}/orgs/${organizationId}/users/${idUser}/activate`,
    request,
  );
  const response_1 = response.data;
  return response_1.data;
};

const resetPasswordUser = async (
  idUser: ID,
  request: {
    password: string;
    confirmPassword: string;
  },
): Promise<User | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const response = await axios.patch(
    `${USER_URL}/orgs/${organizationId}/users/${idUser}/reset-password`,
    request,
  );
  const response_1 = response.data;
  return response_1.data;
};

const getUserTabletActivityLog = async (query: string): Promise<UsersQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const d = await axios.get(
    `${USER_URL}/activity-log/orgs/${organizationId}/login-activity-log?${query}`,
  );
  return {
    data: d.data.data,
  };
};

const updateActivityLogRemark = async (
  activityLogId: ID,
  request: { remark: string },
): Promise<void> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;
  await axios.post(
    `${USER_URL}/activity-log/orgs/${organizationId}/login-activity-log/${activityLogId}/remark`,
    request,
  );
};

export {
  getUsers,
  deleteUser,
  getUserById,
  createUser,
  updateUser,
  changeStatusUser,
  resetPasswordUser,
  getUserTabletActivityLog,
  updateActivityLogRemark,
};
